import { render, staticRenderFns } from "./NoCommittee.vue?vue&type=template&id=46ca5471"
import script from "./NoCommittee.vue?vue&type=script&lang=js"
export * from "./NoCommittee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports